import api from './api';
import { Kunde, CreateKundeRequest, UpdateKundeRequest, Grab } from '../types';

export const kundeService = {
  getAll: async (): Promise<Kunde[]> => {
    const response = await api.get('/kunden');
    return response.data;
  },
  getById: async (id: number): Promise<Kunde> => {
    const response = await api.get(`/kunden/${id}`);
    return response.data;
  },
  search: async (query: string): Promise<Kunde[]> => {
    const response = await api.get(`/kunden/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },
  // Mögliche Dubletten (gleicher Vor-/Nachname + PLZ) – für die Warnung beim Anlegen.
  findDuplikate: async (vorname: string, nachname: string, plz?: string): Promise<Kunde[]> => {
    const params = new URLSearchParams({ vorname, nachname });
    if (plz) params.set('plz', plz);
    const response = await api.get(`/kunden/duplikate?${params.toString()}`);
    return response.data;
  },
  create: async (data: CreateKundeRequest): Promise<Kunde> => {
    const response = await api.post('/kunden', data);
    return response.data;
  },
  update: async (id: number, data: UpdateKundeRequest): Promise<Kunde> => {
    const response = await api.put(`/kunden/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/kunden/${id}`);
  },
  // Replaces the complete set of graves directly assigned to this customer.
  setGraeber: async (id: number, grabIds: number[]): Promise<Grab[]> => {
    const response = await api.put(`/kunden/${id}/graeber`, { grabIds });
    return response.data;
  }
};

export default kundeService;
